import { render } from "./vc4a-select.vue?vue&type=template&id=e415dcfe"
import script from "./vc4a-select.vue?vue&type=script&lang=js"
export * from "./vc4a-select.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/runner/work/vc4a/vc4a/wp-content/themes/vc4africa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__